import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip, Legend } from 'chart.js';

/* --------------------------------------------------
                Register Chart Components
-------------------------------------------------- */
Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip, Legend);
 
/* --------------------------------------------------
                Load Event Listener
-------------------------------------------------- */
document.addEventListener('turbo:load', function() {

  /* Remove Existing Charts */
  if (window.__heartbeatCharts && window.__heartbeatCharts.resizeHandler) {
    window.removeEventListener('resize', window.__heartbeatCharts.resizeHandler);
  }

  /* Initialize Charts Map */
  const charts = new Map();

  /* Create Individual Charts */
  const createIndividualChart = (canvasId, data, color, label) => {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const chartLabels = JSON.parse(canvas.getAttribute('data-months'));
    const chartData = JSON.parse(canvas.getAttribute('data-values'));
    const chartColor = canvas.getAttribute('data-color');

    if (charts.has(canvasId)) {
      try { charts.get(canvasId).destroy(); } catch (e) {}
      charts.delete(canvasId);
    }

    const chart = new Chart(canvas, {
      type: 'line',
      data: {
        labels: chartLabels,
        datasets: [{
          label: label,
          data: chartData,
          borderColor: chartColor,
          backgroundColor: hexToRgba(chartColor, 0.1),
          tension: 0.4,
          fill: true
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { intersect: false },
        plugins: { 
          legend: { 
            display: false,
            labels: {
              font: {
                family: 'Geist, sans-serif'
              }
            }
          } 
        },
        animation: { duration: 300 },
        scales: {
          x: { 
            display: true, 
            ticks: { 
              color: '#6b7280',
              font: {
                family: 'Geist, sans-serif'
              }
            }, 
            grid: { color: '#e5e7eb' } 
          },
          y: { 
            display: true, 
            ticks: { 
              color: '#6b7280',
              font: {
                family: 'Geist, sans-serif'
              }
            }, 
            grid: { color: '#e5e7eb' } 
          }
        }
      }
    });

    charts.set(canvasId, chart);
  };

  /* Helper Functions */
  const hexToRgba = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  /* Initialize All Charts */
  const renderAllCharts = () => {
    createIndividualChart('downloadsChart', null, null, 'Downloads');
    createIndividualChart('projectsChart', null, null, 'Projects');
    createIndividualChart('customersChart', null, null, 'New Customers');
    createIndividualChart('leadsChart', null, null, 'Leads');
  };

  renderAllCharts();

  /* Debounce Utility */
  const debounce = (fn, wait = 150) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(null, args), wait);
    };
  };

  /* Resize Handler */
  const resizeHandler = debounce(() => {
    renderAllCharts();
  }, 200);

  /* Add Resize Listener */
  window.addEventListener('resize', resizeHandler);
  window.__heartbeatCharts = { charts, resizeHandler };
}); 

/* --------------------------------------------------
                Destroy Charts on Cache
-------------------------------------------------- */
document.addEventListener('turbo:before-cache', function() {
  if (window.__heartbeatCharts && window.__heartbeatCharts.charts) {
    window.__heartbeatCharts.charts.forEach((chart) => {
      try { chart.destroy(); } catch (e) {}
    });
    window.__heartbeatCharts.charts.clear();
  }
  if (window.__heartbeatCharts && window.__heartbeatCharts.resizeHandler) {
    window.removeEventListener('resize', window.__heartbeatCharts.resizeHandler);
  }
  window.__heartbeatCharts = null;
});